import { Subject } from 'rxjs';
import { ICategoryDto } from '../../models/CategoryDto';
import { IProductDto } from '../../models/ProductDto';

const productsSubject = new Subject<IProductDto[]>();
const parsedCatalogSubject = new Subject<string>();
const tabSelectionSubject = new Subject<boolean>();
const tryToInsertSubject = new Subject<any>();
const fromAddProductSubject = new Subject<ICategoryDto>();

export const dataStore = {
    publishProductsData: (products: IProductDto[]) => productsSubject.next(products),
    clearProductsData: () => productsSubject.next(undefined),
    getProductsDataObserver: () => productsSubject.asObservable(),

    publishCatalogData: (catalog: string) => parsedCatalogSubject.next(catalog),
    clearCachedCatalog: () => parsedCatalogSubject.next(undefined),
    getParsedCatalogObserver: () => parsedCatalogSubject.asObservable(),

    publishTabSelectionData: (checked: boolean) => {
        console.log("Publish tab selection: " + checked)
        tabSelectionSubject.next(checked);
    },
    getTabSelectionObserver: () => tabSelectionSubject.asObservable(),

    tryToInsertProductData: (data: any) => tryToInsertSubject.next(data),
    getTryToInsertProductObserver: () => tryToInsertSubject.asObservable(),
    clearTryToInsertCache: () => tryToInsertSubject.next(undefined),

    publishCategoryFromAddProduct: (category: ICategoryDto) => fromAddProductSubject.next(category),
    getCategoryFromAddProductObservable: () => fromAddProductSubject.asObservable(),
    clearCategoryFromAddProduct: () => fromAddProductSubject.next(undefined)
}